<script>
    import appConfig from "../../../app.config";
    import "swiper/swiper-bundle.css";
    import axios from 'axios';
    import Swal from 'sweetalert2';
    import TermsConditionsModal from "@/components/modals/terms-conditions-modal.vue";
    // import animationData from "@/components/widgets/lupuorrc.json";
    // import Lottie from "@/components/widgets/lottie.vue";


    // this.$route.params.hash
    export default {
        page: {
            title: "Starter",
            meta: [{
                name: "description",
                content: appConfig.description
            }],
        },
        data() {
            return {
                title: "Starter",
                items: [{
                        text: "Pages",
                        href: "/",
                    },
                    {
                        text: "Starter",
                        active: true,
                    },
                ],
                status:'',
                retry:0,
            };
        },



        methods: {
            getCustomer(){
                this.customerId = '';
                axios.get(process.env.VUE_APP_API_BASEURL+'check/curlect_cc/'+this.$route.params.id+'/'+this.$route.params.hash)
                .then(response => {
                    if (response) {
                        if (typeof response.data.cusId !== 'undefined') {
                            this.customerId = response.data.cusId;
                        }
                        // window.location.href=response.data.url;

                        // console.log(this.dataCustomer);       
                        console.log(response.data) 
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },


            cekFund(){
                this.retry = this.retry +1;
                this.loadingCreditCheck = true;
                // alert(this.companyname);
             
                setTimeout(()=>this.checkingpopup());
               
                axios.get(process.env.VUE_APP_API_BASEURL+'curlec/cheking/'+this.customerId+'/'+this.retry)
                .then(response => {
                this.loadingCreditCheck = true;
           
                    if (response)
                    {
                        Swal.close();
                        if(response.data=='approved')
                        {
                            this.succespg = true;
                            this.emplypg = true;
                        
                            var dataTocurlec = JSON.stringify({
                                "customerId": this.customerId,
                            });

                            var config = {
                                method: 'post',
                                url: process.env.VUE_APP_API_NODEJS+'/v2/generateInstantPayLink',
                                headers: { 
                                    'Content-Type': 'application/json'
                                },
                                data: dataTocurlec,
                            };

                            axios(config)
                            .then(function (response) {
                                if (typeof response.data.url !== 'undefined') {
                                    window.location.href = response.data.url;
                                }
                                // console.log(JSON.stringify(response.data));
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                            
                            this.CreditSubmitCheck=false;
                        }
                        else if(response.data=='pending'){
                            this.retryCheckCredit = this.retryCheckCredit - 1;
                            Swal.fire({
                                title: 'Credit check connection failure',
                                text: "We’re experiencing connectivity issue. Auto Retry in 60 seconds",
                                icon: 'error',
                            });
                            setTimeout(()=>this.cekFund(),10000);
                        }
                        else if(response.data.status == 'timeout'){
                            Swal.fire({
                                title: ' Credit check connection failure',
                                text:   "We’re sorry! but we’re facing some technical difficulties. Please try again later",
                                icon: 'error',
                            
                            }).then((result) => {
                                    if (result.value) {
                                        if(typeof response.data.url !== 'undefined'){
                                            window.location.href = response.data.url;
                                        }
                                    }
                                });
                        }
                        else{
                            this.emplypg = false;
                            this.succespg = false;
                            Swal.fire({
                                title: 'Credit Check Fail !',
                                text:   "We’re sorry! Unfortunately, your application for the ReNew+ Subscription Program is unsuccessful. We recommend that you explore other payment options available on Switch online store. Thank you.",
                                icon: 'error',
                            
                            }).then((result) => {
                                if (result.value) {
                                    if(typeof response.data.url !== 'undefined'){
                                        window.location.href = response.data.url;
                                    }
                                    this.loadingCreditCheck = false;
                                }
                            });
                            this.CreditSubmitCheck=true;
                        }
                        
                    } 
                    else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.OrderSeen = false;
                });
                
                Swal.close();
            }, 

            checkingpopup(){
                Swal.fire({
                    title: 'Checking',
                    text:   "Please DO NOT close or refresh this page until the result is displayed",
                    icon: 'warning',
                    showConfirmButton: false,
                    // timer: 3000,
                    allowOutsideClick: false,
                }); 
            },
        },

        
        components: {
            TermsConditionsModal,

        },
        mounted(){
            this.getCustomer();

            this.$refs.openmodal.click();
            // document.getElementById(pdpaModal)
        }
    };
</script>

<style >
    #container{
    padding-top:20px;
    margin-top:20px;
    width:100vw;
    color:white;
    background-color:#003E30;
    display:flex;
    flex-direction:column;
    align-items:center;
    position:fixed;
    bottom:0;
    }
    #contacts{
    display:flex;
    justify-content:space-around;
    align-items:center;
    width:100%;
    }
    #contacts--contact{
    text-align:right;
    }
    #contacts--social{
    width:20%;
    display : flex;
    justify-content : space-between;
    }
    #contacts--social div{
    height:30px;
    width:30px;
    background-color:white;
    border-radius:50%;
    }
    #mentions p {
    font-size:0.5em;
    }
    .card {
    margin-bottom: -9.5rem !important;
    }
    /* .progress-nav .progress {
        position: absolute;
        left: 0;
        top: 50%;
        transform: rotate(-90deg);
        width: 100%;
    }    
        
    .progress-nav .nav {
        margin-right: -1rem;
        margin-left: -1rem;
        justify-content: space-between;
        transform: rotate(90deg);
    }
        
    .progress-nav .nav .nav-link {
        width: 2rem;
        height: 2rem;
        background-color: var(--vz-light);
        padding: 0;
        color: var(--vz-dark);
        font-weight: 400;
        transform: rotate(-90deg);
    } */
 
    @media (min-width: 1025px) and (max-width: 2399px){
           
        .progress-nav .progress {
            position: absolute;
            left: -86%;
            top: 54%;
            width: 173%;
            transform: rotate(90deg);
            /* background-color: #77BF4C !important;*/
        }
    }

    @media (min-width: 2400px) and (max-width: 3399px){
           
           .progress-nav .progress {
            position: absolute;
            left: -42.5%;
            top: 60%;
            width: 85%;
            transform: rotate(90deg);
            /* background-color: #77BF4C !important;*/
           }
       }
        

    .tabinfo{
        font-size: 16px;
        white-space: nowrap;
        margin-top: 5px;
        padding-left: 5px;
    }
    .fixed-top {
        background-color: #F3F4F6 !important;
    }
    .navbar {
    padding-top: 0px !important;
    /* padding-bottom: 0px !important; */
    }
    .container-fluid{
    padding-right: 0px !important;
    padding-left: 0px !important;
    }
    .progress-nav .nav .nav-link.active, .progress-nav .nav .nav-link.done {
    background-color: #77BF4C !important;
    }
    .progress-bar {
        background-color: #77BF4C !important;
    }
    .pt-tab {
    padding-top: 7rem;
    }
    .btn-primary:hover {
        color: #fff;
        background-color: #77BF4C;
        border-color: #77BF4C;
    }
    .btn {
        color: #fff;
        background-color: #77BF4C !important;
        border-color: #77BF4C !important;
    }
    .form-check-input:checked {
        background-color: #77bf4c !important;
        border-color: #77bf4c !important;
    }
</style>

<template>
    <div class="layout-wrapper landing">

        <nav class="navbar navbar-expand-lg fixed-top" id="navbar">
            <div class="container">
                <a class="navbar-brand" href="index.html">
                    <img style="width: 95px" src="https://renewp.compasia.com/assets/images/logo.png" class="img-fluid card-logo card-logo-dark" alt="logo dark" >
                    <img src="https://renewp.compasia.com/assets/images/logo.png" class="card-logo card-logo-light" alt="logo light" >
                </a>
            </div>
        </nav>

        <section class="section pb-0 hero-section" id="hero" >
        <!-- start hero section -->
            <button ref='openmodal' data-bs-toggle="modal" data-bs-target="#pdpaModal" class='d-none'>.</button>
            <div class="text-center mt-5">
            
                <TermsConditionsModal ref="pdpaModal" @cekFund='cekFund()'></TermsConditionsModal>

            </div>


                    
            <div id="container">
                        <div id="contacts">
                        <div id="contacts--contact">
                            <div>{{ new Date().getFullYear()  }} &copy; CompAsia</div>
                        </div>
                        <div >
                            <div></div>
                            <div></div>
                            <div>Design & Develop by Compasia IT</div>
                        </div>
                        </div>
                        <div id="mentions">
                        <p></p>
                        </div>
            </div>
        </section>
    </div>
    
</template>